import React from "react";

/**
 * LoadingState - Shared loading indicator for admin components
 *
 * @param {boolean} compact - If true, renders as a card suitable for inline display
 * @param {string} label - Loading message to display (default: "Loading...")
 */
function LoadingState({ compact = false, label = "Loading..." }) {
  if (compact) {
    return (
      <div className="card mb-4 border-secondary" style={{ borderLeftWidth: "4px" }}>
        <div className="card-body">
          <div className="d-flex align-items-center">
            <div className="spinner-border spinner-border-sm text-secondary me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="text-muted">{label}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center p-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3">{label}</p>
    </div>
  );
}

export default LoadingState;
